
import EventPublisher from "../utils/EventPublisher";
import SecureRequestExecuter from "./requestExecuters/SecureRequestExecuter";
import SecureResponseHandler from "./ResponseHandlers/SecureResponseHandler";
import ActionResultEvents from "../constants/events/ActionResultEvents";


class CheckoutResponse {

    constructor(
        reservationRequest,
        amount,
        taxRate,
        taxesDue,
        total,
        stripeClientSecret
    ) {
        this.reservationRequest = reservationRequest;
        this.amount = amount;
        this.taxRate = taxRate;
        this.taxesDue = taxesDue;
        this.total = total;
        this.stripeClientSecret = stripeClientSecret;
    }
}

class ReservationRequest {
    constructor(
        reservationRequestId,
        advertisementId,
        advertisementTitle,
        spaceId,
        spaceTitle,
        statusId,
        statusName,
        startDate,
        endDate,
        pricePerDay,
        created,
        updated,
        deleted
    ) {
        this.reservationRequestId = reservationRequestId;
        this.advertisementId = advertisementId;
        this.advertisementTitle = advertisementTitle;
        this.spaceId = spaceId;
        this.spaceTitle = spaceTitle;
        this.statusId = statusId;
        this.statusName = statusName;
        this.startDate = startDate;
        this.endDate = endDate;
        this.pricePerDay = pricePerDay;
        this.created = created;
        this.updated = updated;
        this.deleted = deleted;
    }
}


export default class CheckoutAPIClient {
    constructor() {
        this.createCheckoutSessionResponseHandler =
            new SecureResponseHandler(
                new Map()
                    .set("CHECKOUT_SESSION_CREATED", this.onCheckoutSessionCreated));
        this.markPaymentResponseHandler =
            new SecureResponseHandler(
                new Map()
                    .set("PAYMENT_SUCCESSFUL", this.onPaymentMarked));
    }

    createCheckoutSession(requestReservationId) {
        SecureRequestExecuter.executePOSTRequest(
            "/api/private/checkout_session",
            {},
            {
                "reservation_request_id": requestReservationId,
            },
            {},
            this.createCheckoutSessionResponseHandler
        );
    }

    markReservationAsPaid(requestReservationId) {
        SecureRequestExecuter.executePUTRequest(
            "/api/private/mark_paid",
            {},
            {
                "reservation_request_id": requestReservationId,
            },
            {},
            this.markPaymentResponseHandler
        );
    }

    onPaymentMarked = (responseHeaders, responseBodyContents, dataFromAction) => {
        EventPublisher.publish(ActionResultEvents.CHECKOUT_PAYMENT_SUCCESS, {});
    };

    onCheckoutSessionCreated = (responseHeaders, responseBodyContents, dataFromAction) => {
        EventPublisher.publish(
            ActionResultEvents.CHECKOUT_SESSION_CREATED,
            new CheckoutResponse(
                new ReservationRequest(
                    responseBodyContents["reservation_request"]["reservation_request_id"],
                    responseBodyContents["reservation_request"]["advertisement_id"],
                    responseBodyContents["reservation_request"]["advertisement_title"],
                    responseBodyContents["reservation_request"]["space_id"],
                    responseBodyContents["reservation_request"]["space_title"],
                    responseBodyContents["reservation_request"]["status_id"],
                    responseBodyContents["reservation_request"]["status_name"],
                    responseBodyContents["reservation_request"]["start_date"],
                    responseBodyContents["reservation_request"]["end_date"],
                    responseBodyContents["reservation_request"]["price_per_day"],
                    responseBodyContents["reservation_request"]["created"],
                    responseBodyContents["reservation_request"]["updated"],
                    responseBodyContents["reservation_request"]["deleted"]
                ),
                responseBodyContents["amount"],
                responseBodyContents["tax_rate"],
                responseBodyContents["taxes_due"],
                responseBodyContents["total"],
                responseBodyContents["client_secret"]));
    };

}